import { Badge } from "@/components/ui/badge";
import { Platform } from "@/types/enums";
import { cn } from "@/lib/utils";

interface PlatformBadgeProps {
  platform: Platform;
  className?: string;
}

const PLATFORM_CONFIG: Record<
  Platform,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
  }
> = {
  [Platform.TOSS]: {
    label: "TOSS",
    variant: "outline",
    className: "bg-indigo-100 text-indigo-800 border-indigo-300",
  },
  [Platform.IOS]: {
    label: "IOS",
    variant: "outline",
    className: "bg-zinc-100 text-zinc-800 border-zinc-300",
  },
  [Platform.ANDROID]: {
    label: "ANDROID",
    variant: "outline",
    className: "bg-green-100 text-green-800 border-green-300",
  },
  [Platform.STRIPE]: {
    label: "STRIPE",
    variant: "outline",
    className: "bg-purple-100 text-purple-800 border-purple-300",
  },
};

export function PlatformBadge({ platform, className }: PlatformBadgeProps) {
  const config = PLATFORM_CONFIG[platform];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
      aria-label={`Platform: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
